var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, useParams } from 'react-router-dom';
import { Box, LoadingBox, translate } from '@lucidlink/uicore';
import { useCurrentMemberByWorkspaceId } from '#query-hooks';
import { workspaceRoutes } from '#services';
export const PrivilegeRouteGuard = ({ children, requiredPrivileges, }) => {
    _react_refresh_temp_2();
    const { workspaceId = '' } = useParams();
    const { query: { data, isPending }, } = useCurrentMemberByWorkspaceId(workspaceId);
    if (isPending) {
        return (_jsx(Box, { align: "center", isFullHeight: true, isFullWidth: true, justify: "center", children: _jsx(LoadingBox, { alt: translate('Checking your privileges'), "data-testid": "checking-privileges", isFullHeight: true }) }));
    }
    if (data?.privileges === undefined ||
        !hasRequiredPrivileges(requiredPrivileges, data.privileges)) {
        return _jsx(Navigate, { to: workspaceRoutes.workspace(workspaceId) });
    }
    return children;
};
_react_refresh_temp_1 = PrivilegeRouteGuard;
$RefreshReg$(_react_refresh_temp_1, "PrivilegeRouteGuard");
_react_refresh_temp_2(PrivilegeRouteGuard, "luSIiY3xqGwdLZdII4gTW4afHQA=", false, () => [useParams, useCurrentMemberByWorkspaceId]);
const hasRequiredPrivileges = (requirements, privilegeFlags) => {
    if (requirements === 'none') {
        return true;
    }
    if (typeof requirements === 'string') {
        return privilegeFlags[requirements] === true;
    }
    if ('AND' in requirements) {
        for (const subRequirements of requirements.AND) {
            if (!hasRequiredPrivileges(subRequirements, privilegeFlags)) {
                return false;
            }
        }
        return true;
    }
    if ('OR' in requirements) {
        for (const subRequirements of requirements.OR) {
            if (hasRequiredPrivileges(subRequirements, privilegeFlags)) {
                return true;
            }
        }
        return false;
    }
    return false;
};
